<template>
  <div id="country" v-if="countries.length > 0">

    <div class="form-row pfm-switch disabled" v-if="countries.length == 1">
      <div class="shipping-header header" >
        <div class='radio-wrap'>
          <label class="radio-label">{{countries[0].name}}</label>
        </div>
      </div>
    </div>

    <radio-select v-if="countries.length > 1 && countries.length <= 3"
        :data="this"
        path="selectedCuntry"
        :options="countries"
        @change="radioChanged"/>

    <div class="form-row" v-if="countries.length > 3">
      <select name="country" v-model="contact.country" @change="formUpdated" v>
        <option :value="item.value" v-for="item in countries">{{item.name}}</option>
      </select>
    </div>

  </div>
</template>

<script>
import Cart from '@/cart'

import RadioSelect from '../common/RadioField'

export default {
  props: ['contact'],
  components: {
    RadioSelect
  },
  data() {
    return {
      lang: Cart.lang,
      countries: [
        {name: 'Česká republika', value: 'CZ'},
        // {name: 'Slovenska republika', value: 'SK'},
        // {name: 'England', value: 'GB'}
      ],
      selectedCuntry: this.contact.country ? this.contact.country : 'CZ'
    }
  },
  created() {
    console.log('CountrySelect::created', this.contact)
    this.contact.country = '--'
    if (this.countries.length == 1) {
      this.contact.country = this.countries[0].value
      this.$emit('updated')
    }
  },
  methods: {
    radioChanged() {
      this.contact.country = this.selectedCuntry
      console.log('Radio value', this.contact.country)
      this.$emit('updated')
    },
    formUpdated() {
      console.log('Selected value')
      this.$emit('updated')
    },
  }
}
</script>

<style>
</style>
